export default __webpack_public_path__ + "static/media/churn_assistance_capture_your_screen.aa29af3c.gif";